import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Handshake, House } from "lucide-react";
import Logo from "../assets/log.jpg";

const LoginPage = () => {
  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="space-y-16">
      {/* Header with logo and text */}
      <motion.div
        className="flex items-center justify-center gap-8"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <img className="h-20 w-20" src={Logo} alt="logo" />
        <p className="text-2xl font-bold text-indigo-900">Life Groups</p>
      </motion.div>

      {/* Cards from the bottom */}
      <div className="flex flex-col items-center justify-center gap-8 sm:flex-row sm:gap-16">
        {/* Housing Card */}
        <motion.div
          onClick={() =>
            openInNewTab("http://housing.lifedeegrand.com/sign-in")
          }
          className="w-xs h-50 flex cursor-pointer flex-col items-center justify-center gap-4 rounded-2xl border border-indigo-600 p-4"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          whileHover={{
            scale: 1.05,
            boxShadow: "0px 8px 24px rgba(99, 102, 241, 0.4)",
          }}
        >
          <div className="flex w-full justify-center gap-4">
            <House />
            <span>Housing</span>
          </div>
          <Button className="w-3xs">Sign In</Button>
        </motion.div>

        {/* Alliance Card */}
        <motion.div
          onClick={() =>
            openInNewTab("http://alliance.lifedeegrand.com/sign-in")
          }
          className="w-xs h-50 flex cursor-pointer flex-col items-center justify-center gap-4 rounded-2xl border border-indigo-600 p-4"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          whileHover={{
            scale: 1.05,
            boxShadow: "0px 8px 24px rgba(99, 102, 241, 0.4)",
          }}
        >
          <div className="flex w-full justify-center gap-4">
            <Handshake />
            <span>Alliance</span>
          </div>
          <Button className="w-3xs">Sign In</Button>
        </motion.div>
      </div>
    </section>
  );
};

export default LoginPage;
